import {type AuthProviderProps} from 'react-oidc-context';

import {WebStorageStateStore} from 'oidc-client-ts';

import {getMetaTagContent} from './modules/common/helpers/getMetaTag';
import {routes} from './routes';

const {
  VITE_APP_SERVER_URI,
  VITE_APP_SSO_CLIENT_ID,
  VITE_APP_SSO_REALM,
  VITE_APP_SSO_URI,
} = import.meta.env;

export const config = {
  toastyAutoHideDuration: 3500, // 3.5 seconds
  tableTheme: {
    nestedLevels: {
      light: {level1: '#eee', level2: '#e3e3e3'},
      dark: {level1: '#242424', level2: '#323232'},
    },
  },
  theme: {
    gutterSpacing: 1,
    primaryDefault: '#F26722',
    secondaryDefault: '#4D4D4D',
  },
  serverUri: getMetaTagContent(
    'app:server-uri',
    VITE_APP_SERVER_URI,
    'http://localhost:5000',
  ),
  get sso() {
    const uri = getMetaTagContent('app:sso-uri', VITE_APP_SSO_URI);
    const realm = getMetaTagContent('app:sso-realm', VITE_APP_SSO_REALM);
    const clientId = getMetaTagContent(
      'app:sso-client-id',
      VITE_APP_SSO_CLIENT_ID,
    );

    const oidcConfig: AuthProviderProps = {
      client_id: clientId,
      authority: `${uri}/auth/realms/${realm}`,
      redirect_uri: `${window.location.origin}${routes.auth.redirect}`,
      scope: 'openid profile email',
      revokeTokensOnSignout: true,
      userStore: new WebStorageStateStore({store: window.localStorage}), // Use LocalStorage here
      onSigninCallback: () => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      },
    };

    return {
      uri,
      realm,
      clientId,
      oidcConfig,
      ssoLogoutNavigators: ['signoutRedirect', 'signoutPopup', 'signoutSilent'],
      ssoLoginNavigators: [
        'signinRedirect',
        'signinResourceOwnerCredentials',
        'signinPopup',
        'signinSilent',
      ],
    };
  },
  version: {
    frontendVersion: getMetaTagContent('app:version', '0.0.0'),
    // onroadvantageApiPackageVersion: (
    //   packageJson.dependencies['@onroadvantage/onroadvantage-api'] ?? '0.0.0'
    // ).replace('^', ''),
  },
} as const;
